/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OtherPaymentMethod } from './OtherPaymentMethod';
import {
    OtherPaymentMethodFromJSON,
    OtherPaymentMethodFromJSONTyped,
    OtherPaymentMethodToJSON,
    OtherPaymentMethodToJSONTyped,
} from './OtherPaymentMethod';
import type { CardPaymentMethod } from './CardPaymentMethod';
import {
    CardPaymentMethodFromJSON,
    CardPaymentMethodFromJSONTyped,
    CardPaymentMethodToJSON,
    CardPaymentMethodToJSONTyped,
} from './CardPaymentMethod';
import type { SubscriptionInvoice } from './SubscriptionInvoice';
import {
    SubscriptionInvoiceFromJSON,
    SubscriptionInvoiceFromJSONTyped,
    SubscriptionInvoiceToJSON,
    SubscriptionInvoiceToJSONTyped,
} from './SubscriptionInvoice';
import type { BillingDetails } from './BillingDetails';
import {
    BillingDetailsFromJSON,
    BillingDetailsFromJSONTyped,
    BillingDetailsToJSON,
    BillingDetailsToJSONTyped,
} from './BillingDetails';

/**
 * 
 * @export
 * @interface SubscriptionStatusDetails
 */
export interface SubscriptionStatusDetails {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionStatusDetails
     */
    paymentStatus: SubscriptionStatusDetailsPaymentStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionStatusDetails
     */
    paymentMethodStatus: SubscriptionStatusDetailsPaymentMethodStatusEnum;
    /**
     * 
     * @type {CardPaymentMethod}
     * @memberof SubscriptionStatusDetails
     */
    paymentMethod?: CardPaymentMethod;
    /**
     * 
     * @type {OtherPaymentMethod}
     * @memberof SubscriptionStatusDetails
     */
    otherPaymentMethod?: OtherPaymentMethod;
    /**
     * 
     * @type {BillingDetails}
     * @memberof SubscriptionStatusDetails
     */
    billingDetails?: BillingDetails;
    /**
     * 
     * @type {Date}
     * @memberof SubscriptionStatusDetails
     */
    overdueSince?: Date;
    /**
     * 
     * @type {Date}
     * @memberof SubscriptionStatusDetails
     */
    nextPaymentDate: Date;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionStatusDetails
     */
    nextPaymentAmount: number;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionStatusDetails
     */
    nextPaymentDescription?: string;
    /**
     * 
     * @type {Date}
     * @memberof SubscriptionStatusDetails
     */
    lastPaymentDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof SubscriptionStatusDetails
     */
    cancellationDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof SubscriptionStatusDetails
     */
    trialEndDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof SubscriptionStatusDetails
     */
    estimatedPaymentMethodRequiredDate?: Date;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionStatusDetails
     */
    credits?: number;
    /**
     * 
     * @type {Array<SubscriptionInvoice>}
     * @memberof SubscriptionStatusDetails
     */
    invoices?: Array<SubscriptionInvoice>;
    /**
     * 
     * @type {Date}
     * @memberof SubscriptionStatusDetails
     */
    scheduledCancellationDate?: Date;
}


/**
 * @export
 */
export const SubscriptionStatusDetailsPaymentStatusEnum = {
    UpToDate: 'UpToDate',
    Overdue: 'Overdue',
    Cancelled: 'Cancelled',
    Pending: 'Pending',
    Trialing: 'Trialing',
    Paused: 'Paused'
} as const;
export type SubscriptionStatusDetailsPaymentStatusEnum = typeof SubscriptionStatusDetailsPaymentStatusEnum[keyof typeof SubscriptionStatusDetailsPaymentStatusEnum];

/**
 * @export
 */
export const SubscriptionStatusDetailsPaymentMethodStatusEnum = {
    Valid: 'Valid',
    Rejected: 'Rejected',
    Missing: 'Missing',
    Expired: 'Expired',
    Pending: 'Pending'
} as const;
export type SubscriptionStatusDetailsPaymentMethodStatusEnum = typeof SubscriptionStatusDetailsPaymentMethodStatusEnum[keyof typeof SubscriptionStatusDetailsPaymentMethodStatusEnum];


/**
 * Check if a given object implements the SubscriptionStatusDetails interface.
 */
export function instanceOfSubscriptionStatusDetails(value: object): value is SubscriptionStatusDetails {
    if (!('paymentStatus' in value) || value['paymentStatus'] === undefined) return false;
    if (!('paymentMethodStatus' in value) || value['paymentMethodStatus'] === undefined) return false;
    if (!('nextPaymentDate' in value) || value['nextPaymentDate'] === undefined) return false;
    if (!('nextPaymentAmount' in value) || value['nextPaymentAmount'] === undefined) return false;
    return true;
}

export function SubscriptionStatusDetailsFromJSON(json: any): SubscriptionStatusDetails {
    return SubscriptionStatusDetailsFromJSONTyped(json, false);
}

export function SubscriptionStatusDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscriptionStatusDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'paymentStatus': json['paymentStatus'],
        'paymentMethodStatus': json['paymentMethodStatus'],
        'paymentMethod': json['paymentMethod'] == null ? undefined : CardPaymentMethodFromJSON(json['paymentMethod']),
        'otherPaymentMethod': json['otherPaymentMethod'] == null ? undefined : OtherPaymentMethodFromJSON(json['otherPaymentMethod']),
        'billingDetails': json['billingDetails'] == null ? undefined : BillingDetailsFromJSON(json['billingDetails']),
        'overdueSince': json['overdueSince'] == null ? undefined : (new Date(json['overdueSince'])),
        'nextPaymentDate': (new Date(json['nextPaymentDate'])),
        'nextPaymentAmount': json['nextPaymentAmount'],
        'nextPaymentDescription': json['nextPaymentDescription'] == null ? undefined : json['nextPaymentDescription'],
        'lastPaymentDate': json['lastPaymentDate'] == null ? undefined : (new Date(json['lastPaymentDate'])),
        'cancellationDate': json['cancellationDate'] == null ? undefined : (new Date(json['cancellationDate'])),
        'trialEndDate': json['trialEndDate'] == null ? undefined : (new Date(json['trialEndDate'])),
        'estimatedPaymentMethodRequiredDate': json['estimatedPaymentMethodRequiredDate'] == null ? undefined : (new Date(json['estimatedPaymentMethodRequiredDate'])),
        'credits': json['credits'] == null ? undefined : json['credits'],
        'invoices': json['invoices'] == null ? undefined : ((json['invoices'] as Array<any>).map(SubscriptionInvoiceFromJSON)),
        'scheduledCancellationDate': json['scheduledCancellationDate'] == null ? undefined : (new Date(json['scheduledCancellationDate'])),
    };
}

export function SubscriptionStatusDetailsToJSON(json: any): SubscriptionStatusDetails {
    return SubscriptionStatusDetailsToJSONTyped(json, false);
}

export function SubscriptionStatusDetailsToJSONTyped(value?: SubscriptionStatusDetails | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'paymentStatus': value['paymentStatus'],
        'paymentMethodStatus': value['paymentMethodStatus'],
        'paymentMethod': CardPaymentMethodToJSON(value['paymentMethod']),
        'otherPaymentMethod': OtherPaymentMethodToJSON(value['otherPaymentMethod']),
        'billingDetails': BillingDetailsToJSON(value['billingDetails']),
        'overdueSince': value['overdueSince'] == null ? undefined : ((value['overdueSince']).toISOString()),
        'nextPaymentDate': ((value['nextPaymentDate']).toISOString()),
        'nextPaymentAmount': value['nextPaymentAmount'],
        'nextPaymentDescription': value['nextPaymentDescription'],
        'lastPaymentDate': value['lastPaymentDate'] == null ? undefined : ((value['lastPaymentDate']).toISOString()),
        'cancellationDate': value['cancellationDate'] == null ? undefined : ((value['cancellationDate']).toISOString()),
        'trialEndDate': value['trialEndDate'] == null ? undefined : ((value['trialEndDate']).toISOString()),
        'estimatedPaymentMethodRequiredDate': value['estimatedPaymentMethodRequiredDate'] == null ? undefined : ((value['estimatedPaymentMethodRequiredDate']).toISOString()),
        'credits': value['credits'],
        'invoices': value['invoices'] == null ? undefined : ((value['invoices'] as Array<any>).map(SubscriptionInvoiceToJSON)),
        'scheduledCancellationDate': value['scheduledCancellationDate'] == null ? undefined : ((value['scheduledCancellationDate']).toISOString()),
    };
}

